import { Injectable } from "@angular/core";

import { ConfirmationModalComponent } from "@lantern/app/common/utils/modals/confirmation-modal.component";
import { ModalRef } from "./modal-ref";

import {
  CONFIRMATION_MODAL_OPTIONS,
  ConfirmationModalOptions
} from "./confirmation-modal-options";
import { ModalService } from "./modal.service";

@Injectable()
export class ConfirmationModalService {
  constructor(private modalService: ModalService) {}

  open(options: ConfirmationModalOptions): ModalRef<boolean> {
    return this.modalService.openComponent(
      ConfirmationModalComponent,
      [
        {
          provide: CONFIRMATION_MODAL_OPTIONS,
          useValue: options
        }
      ],
      (): boolean  => false
    );
  }
}
